import { render } from "./MobileCardList.vue?vue&type=template&id=a5355032&scoped=true"
import script from "./MobileCardList.vue?vue&type=script&lang=js"
export * from "./MobileCardList.vue?vue&type=script&lang=js"

import "./MobileCardList.vue?vue&type=style&index=0&id=a5355032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5355032"]])

export default __exports__